var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87697 2.43478H1.16665C0.522328 2.43478 0 1.88974 0 1.21739C0 0.545045 0.522328 0 1.16665 0H5.83326C6.38932 0 6.86809 0.409512 6.97722 0.97847L7.95707 6.08696H26.833C27.5649 6.08696 28.1161 6.78213 27.979 7.5324L26.1106 17.7554C25.7804 19.4906 24.3057 20.7293 22.633 20.6957L11.3155 20.6954C9.62048 20.7293 8.14587 19.4906 7.81592 17.7572L5.86685 7.59556C5.85894 7.56194 5.85237 7.52778 5.8472 7.49314L4.87697 2.43478ZM8.42404 8.52174L10.1042 17.2811C10.2142 17.8595 10.7058 18.2724 11.2932 18.2609L22.6554 18.2611C23.2204 18.2724 23.7119 17.8595 23.8203 17.2902L25.4228 8.52174H8.42404ZM10.4999 28C9.21122 28 8.16656 26.9099 8.16656 25.5652C8.16656 24.2205 9.21122 23.1304 10.4999 23.1304C11.7885 23.1304 12.8332 24.2205 12.8332 25.5652C12.8332 26.9099 11.7885 28 10.4999 28ZM23.333 28C22.0444 28 20.9997 26.9099 20.9997 25.5652C20.9997 24.2205 22.0444 23.1304 23.333 23.1304C24.6217 23.1304 25.6663 24.2205 25.6663 25.5652C25.6663 26.9099 24.6217 28 23.333 28Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.0cb743d8f587b85aeac351c4218957e9.svg";
export { ForwardRef as ReactComponent };